(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const initialise = (scope) => {
    scope.querySelectorAll('[data-dl-footer]').forEach((footer) => {
      if (footer.dataset.ready) return;
      footer.dataset.ready = 'true';
      const groups = footer.querySelectorAll('.dl-footer-group');
      const sync = () => groups.forEach((group) => { group.open = !mobile.matches; });
      sync();
      mobile.addEventListener('change', sync);
      groups.forEach((group) => {
        group.querySelector('summary').addEventListener('click', (event) => {
          if (!mobile.matches) event.preventDefault();
        });
      });
      footer.addEventListener('shopify:section:unload', () => mobile.removeEventListener('change', sync), { once: true });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
